import { useGetDevicesWithLowBatteryQuery } from "graphqlBase/sensorMeasurementCurrentValues/__generated__/getDevicesWithLowBattery";
import { useCallback } from "react";
import { Device, DeviceListItem } from ".";

const useGetDevicesWithLowBattery = (devices: Device[] | undefined) => {
  const { data: valuesLowBattery, loading: valuesLowBatteryLoading } = useGetDevicesWithLowBatteryQuery();

  const devicesWithLowBattery = useCallback(() => {
    if (!devices || !valuesLowBattery) return;

    const deviceIds: string[] = (valuesLowBattery.sensorMeasurementCurrentValues?.items ?? [])?.map(
      (item) => item?.deviceId ?? ""
    );

    return devices?.reduce<DeviceListItem[]>((devicesLowBattery, current) => {
      if (devicesLowBattery.length < 5) {
        if (deviceIds.find((id) => current.id === id)) {
          const batteryVoltage = valuesLowBattery?.sensorMeasurementCurrentValues?.items?.find(
            (value) => value?.deviceId === current.id && value?.capabilityId === "80bec84b-2c50-4e12-9a70-56b06e5b92e5"
          )?.valueString;
          const batteryChargeStatus = valuesLowBattery?.sensorMeasurementCurrentValues?.items?.find(
            (value) => value?.deviceId === current.id && value?.capabilityId === "3c9e8f2a-1b4d-4e6f-9a8c-7d5b2e4a1c9f"
          )?.valueFloat;

          return devicesLowBattery.concat({
            batteryVoltage,
            batteryChargeStatus,
            deviceName: current.deviceName ?? "",
            deviceId: current.id,
          });
        }
      }
      return devicesLowBattery;
    }, []);
  }, [valuesLowBattery, devices]);

  return {
    devicesLowBattery: devicesWithLowBattery(),
    totalLowBatteryDevicesCount: valuesLowBattery?.sensorMeasurementCurrentValues?.totalCount ?? 0,
    loading: valuesLowBatteryLoading,
  };
};

export default useGetDevicesWithLowBattery;
